module.exports = __webpack_public_path__ + "img/Waze.9510399e.png";